import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { endpoints } from 'global/endpoints';
import { useIntegrationStore } from 'store/useIntegrationStore';
import http from 'utils/http';

interface IADPAuth {
  code: string;
}

const saveADPAuthCode = (postData: IADPAuth) => {
  return http().post(endpoints.integrations.adpSaveAuthCode, postData);
};

export function useSaveADPAuthCode() {
  const navigate = useNavigate();
  const addIntegrationList = useIntegrationStore(state => state.addIntegrationList);

  return useMutation({
    mutationFn: saveADPAuthCode,
    onSuccess: ({ payload }) => {
      addIntegrationList(payload);
      navigate('/integrations/adp/mapping');
    },
  });
}
